module.exports = __webpack_public_path__ + "static/img/2areaB_22.00cd4e5.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/2areaB_22.png
// module id = 1139
// module chunks = 1